'use strict';
import Auth from '@/components/admin/auth/mixins/auth';
import store from '@/store';
import router from '@/router';

const protocol = window.location.protocol.replace(':', '');
export default {
  store,
  router,
  install: (Vue,) => {
    // Plugins
    let instance = new Vue({
      mixins: [Auth]
    });
    const Util = instance.$util;
    const Service = instance.$service;
    const Message = instance.$message;
    const Storage = instance.$storage;
    const Loading = instance.$loading;

    const generadorQueryMutacionEdit = (nombre_tabla) => {
      var nombre_capitalizado = ''
      nombre_tabla.split('_').forEach(element => {
        nombre_capitalizado += Util.capitalizeString(element)
      });
      var plantilla = `
        mutation edit($id: ID!, $${nombre_tabla}: Edit${nombre_capitalizado}!){
          ${nombre_capitalizado.charAt(0).toLowerCase() + nombre_capitalizado.substring(1)}Edit(id: $id, ${nombre_tabla}: $${nombre_tabla}){
            id
          }
        }
      `
      return plantilla
    }
    const generadorQueryMutacionAdd = (nombre_tabla) => {
      var nombre_capitalizado = ''
      nombre_tabla.split('_').forEach(element => {
        nombre_capitalizado += Util.capitalizeString(element)
      });
      var plantilla = `
        mutation add($${nombre_tabla}: New${nombre_capitalizado}!){
          ${nombre_capitalizado.charAt(0).toLowerCase() + nombre_capitalizado.substring(1)}Add(${nombre_tabla}: $${nombre_tabla}){
            id
          }
        }
      `
      return plantilla
    }
    const generadorQuerySelect = (nombre_tabla, filtros, valores) => {
      var nombre_capitalizado = ''
      nombre_tabla.split('_').forEach(element => {
        nombre_capitalizado += Util.capitalizeString(element)
      });
      let titulo_tabla = nombre_capitalizado.charAt(0).toLowerCase() + nombre_capitalizado.substring(1) + 's'
      // Generamos filtros
      var filtro = []
      for (const key in filtros) {
        filtro.push(`${key.toLowerCase()}:${typeof (filtros[key]) === 'string' ? `"${filtros[key]}"` : Array.isArray(filtros[key]) ? `[${filtros[key]}]` : filtros[key]}`);
      }
      var cadena_filtro = ''
      if (filtro.length > 0) {
        cadena_filtro = `(${filtro.join(',')})`
      }
      // Generamos valores a traer
      let valores_formato = valores.join('\n')
      var plantilla = `
        query{
          ${titulo_tabla}${cadena_filtro}{
            rows{
              ${valores_formato}
            }
          }
        }
      `
      return {
        titulo_tabla,
        plantilla
      }
    }
    const generadorQuerySelectConsulta = (nombre_consulta, filtros, valores) => {
      // Generamos filtros
      var filtro = []
      for (const key in filtros) {
        filtro.push(`${key.toLowerCase()}:${typeof (filtros[key]) === 'string' ? `"${filtros[key]}"` : filtros[key]}`);
      }
      var cadena_filtro = ''
      if (filtro.length > 0) {
        cadena_filtro = `(${filtro.join(',')})`
      }
      // Generamos valores a traer
      let valores_formato = valores.join('\n')
      var plantilla = `
        query{
          ${nombre_consulta}${cadena_filtro}{
            ${valores_formato}
          }
        }
      `
      return {
        plantilla
      }
    }
    const generadorQueryCount = (nombre_tabla, filtros) => {
      var nombre_capitalizado = ''
      nombre_tabla.split('_').forEach(element => {
        nombre_capitalizado += Util.capitalizeString(element)
      });
      let titulo_tabla = nombre_capitalizado.charAt(0).toLowerCase() + nombre_capitalizado.substring(1) + 's'
      // Generamos filtros
      var filtro = []
      for (const key in filtros) {
        filtro.push(`${key.toLowerCase()}:${typeof (filtros[key]) === 'string' ? `"${filtros[key]}"` : filtros[key]}`);
      }
      var cadena_filtro = ''
      if (filtro.length > 0) {
        cadena_filtro = `(${filtro.join(',')})`
      }
      var plantilla = `
        query{
          ${titulo_tabla}${cadena_filtro}{
            count
          }
        }
      `
      return {
        titulo_tabla,
        plantilla
      }
    }

    const Querys = {
      //=================================== QUERYS GENERALES ========================================
      async edit(nombre_tabla, id, datos) {
        const id_tabla = parseInt(id)
        try {
          await Service.graphql({
            query: generadorQueryMutacionEdit(nombre_tabla),
            variables: {
              id: id_tabla,
              [nombre_tabla]: datos
            }
          });
        } catch (error) {
          console.log(error);
        }
      },
      async add(nombre_tabla, datos) {
        try {
          let rpta = await Service.graphql({
            query: generadorQueryMutacionAdd(nombre_tabla),
            variables: {
              [nombre_tabla]: datos
            }
          });
          return rpta
        } catch (error) {
          console.log(error);
        }
      },
      async select(nombre_tabla, filtros, valores) {
        const { titulo_tabla, plantilla } = generadorQuerySelect(nombre_tabla, filtros, valores)
        try {
          let rpta = await Service.graphql({
            query: plantilla
          });
          return rpta[titulo_tabla].rows
        } catch (error) {
          console.log(error);
        }
      },
      async selectConsulta(nombre_consulta, filtros, valores) {
        const { plantilla } = generadorQuerySelectConsulta(nombre_consulta, filtros, valores)
        try {
          let rpta = await Service.graphql({
            query: plantilla
          });
          return rpta[nombre_consulta]
        } catch (error) {
          console.log(error);
        }
      },

      async count(nombre_tabla, filtros) {
        const { titulo_tabla, plantilla } = generadorQueryCount(nombre_tabla, filtros)
        try {
          let rpta = await Service.graphql({
            query: plantilla
          });
          return rpta[titulo_tabla].count
        } catch (error) {
          console.log(error);
        }
      }
    };
    Vue.prototype.$query = Querys;
  }
};



// WEBPACK FOOTER //
// ./src/common/plugins/query.js